<template>
  <v-form @submit.prevent ref="form" v-model="valid">
      <message-form :doc="doc" />
      <v-btn class="mt-5" color="amber" @click="onSubmit">Submit</v-btn>
  </v-form>
</template>

<script>
// @ is an alias to /src
import MessageForm from "./MessageForm"
import { mapState } from "vuex";
const fb = require("@/firebaseConfig.js");

export default {
  name: "UserMessageFormAdd",
  components: {
    MessageForm
  },
  data () {
    return {
      valid: true,
      doc: {}
    }
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel"
    ])
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      this.validate();
      if (this.valid) {
         let ref = fb.messageContentCollection.doc();
        ref.set({
          createdOn: new Date(),
          id: ref.id,
          message: this.populateField(this.doc.message),
          uid: this.currentUser.uid,
          pid: this.currentProjectModel.id,

        }).then(() => {
          this.$emit('complete')
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
      }
    },
    populateField(field) {
      return field ? field : null
    },
    validate () {
      this.$refs.form.validate()
    },
  }
};
</script>
